const images = import.meta.glob<{ default: string }>('../../../../../images/sbr-page/carriers/*.svg', { eager: true });

interface ICarrierLogoProps {
    carrierCode: string;
    carrierName: string;
}

const CarrierLogo: React.FC<ICarrierLogoProps> = ({carrierCode, carrierName}) => {
    try {
        const imageSrc  = images[`../../../../../images/sbr-page/carriers/${carrierCode}.svg`].default;
        return <img className={'available-carrier-logo'} src={imageSrc} alt={carrierName} />
    } catch (error) {
        console.error(error);
        return <>{carrierName}</>;
    }
};

export default CarrierLogo;